import React from "react";
import { Box, chakra, Text } from "@chakra-ui/react";

interface TermsAndConditionProps {
  termsPageLink: string;
  onTermsLinkClick(): void;
}

const TermsAndCondition = ({
  onTermsLinkClick,
  termsPageLink,
}: TermsAndConditionProps) => {
  return (
    <Box p="1rem" borderRadius="0.5rem">
      <Text
        fontSize={{ base: "12px", md: "14px" }}
        fontWeight="400"
        textAlign="center"
      >
        By continuing, you agree to our{" "}
        <chakra.a
          color="primary"
          fontWeight={{ base: "400", md: "600" }}
          fontSize="14px"
          href={termsPageLink}
          target="_blank"
          rel="nofollow"
          borderBottom="1px dashed"
          onClick={onTermsLinkClick}
        >
          Terms of Service.
        </chakra.a>
      </Text>
    </Box>
  );
};

export default TermsAndCondition;
